import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SnackbarService } from '../services/snackbar.service';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private snackbarService: SnackbarService,
    private authService: AuthService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Token expired or invalid
          this.handleUnauthorizedError();
        }

        if (error.status === 400 || error.status === 404) {
          let errorMessage = error.error?.message || 'An error occurred';
          if (errorMessage.toLowerCase().includes('recharge')) {
            errorMessage = "Something went wrong."
          }
          this.snackbarService.showError(error.error?.message || 'An error occurred');
        }

        // Forward the error to the component
        return throwError(() => error);
      })
    );
  }

  private handleUnauthorizedError(): void {
    // Show message to user
    this.snackbarService.showError('Your session has expired. Please login again.');

    // Use the auth service to handle the logout process
    this.authService.autoLogout();
  }
} 